import { Dispatch, ReactNode, SetStateAction, Fragment, useState } from "react";
import { WidgetRow } from "../PaddedRow";
import styled from "styled-components";
import { AreaSearchListModal } from "../../../components/TestBuy/TestBuyAreas/AreaSearchListModal";

const MiddleWrapper = styled("div")`
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

interface DivisionProps {
  type: string;
  item: string;
}

interface AreaSelectionProps {
  title: ReactNode;
  selected?: string | ReactNode | undefined;
  onConfirm: (value: string | DivisionProps | string[]) => void;
  onClose?: () => void;
  image?: string | ReactNode;
  testId?: string;
  isAcesAndKing: boolean;
  area: string;
  setArea: Dispatch<SetStateAction<string>>;
  multiSelect?: boolean;
  selectedAreas?: string[];
  maxSelections?: number;
}

export function AreaSelection({
  title,
  selected,
  onConfirm,
  image,
  testId,
  isAcesAndKing = false,
  area,
  setArea,
  multiSelect = false,
  selectedAreas = [],
  maxSelections = 3,
}: AreaSelectionProps) {
  const [openAreaSearchListPopup, setOpenAreaSearchListPopup] = useState(false);
  return (
    <Fragment>
      <WidgetRow
        className="WidgetView"
        image={image}
        middle={
          <MiddleWrapper>
            <b>{selected}</b>
            <p>{title}</p>
          </MiddleWrapper>
        }
        right={<></>}
        onClick={() => setOpenAreaSearchListPopup(true)}
        testId={testId || "area-choices-widget"}
      />
      <AreaSearchListModal
        openAreaSearchListPopup={openAreaSearchListPopup}
        setOpenAreaSearchListPopup={setOpenAreaSearchListPopup}
        onSubmit={(area) => {
          onConfirm(area);
          setOpenAreaSearchListPopup(false);
        }}
        isAcesAndKing={isAcesAndKing}
        area={area ?? ""}
        setArea={setArea ?? (() => {})}
        multiSelect={multiSelect}
        selectedAreas={selectedAreas}
        maxSelections={maxSelections}
      />
    </Fragment>
  );
}
